import PageContent from "@components/pageContent";
import { SanityPageSectionType } from "@sourceful/shared-types";

interface ProductPageContentProps {
  product: {
    productDetailPageContent?: SanityPageSectionType[];
  };
}
const ProductPageContent = ({ product }: ProductPageContentProps) => {
  return (
    <>
      {product?.productDetailPageContent?.length && (
        <PageContent pageContent={product.productDetailPageContent} />
      )}
    </>
  );
};

export default ProductPageContent;
